<template>

  <div v-if="current">

    <v-row>
      <v-col cols="12" sm="3">
        <v-alert dense text type="info">
          {{ counter_contratos }} integrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="3">
        <v-alert dense text type="warning">
          {{ counter_contratos_processados }} processados 
        </v-alert>
      </v-col>
      <v-col cols="12" sm="3">
        <v-alert dense text type="success">
          {{ counter_contratos_faturados }} faturados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn color="primary" @click="faturar()" block>Processar faturamento</v-btn>
      </v-col>
    </v-row>
    
    <v-simple-table>
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Usuário</th>
          <th>Instalação</th>
          <th>Valor</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.clientName }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.setup | formatDate }}</td>
          <td>R$ {{ item.price | formatMoney }}</td>
          <td><v-chip :color="colorStatus(item)" text-color="white" small>{{ item | formatStatus }}</v-chip></td>
        </tr>
      </tbody>
    </v-simple-table>
    
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    current: [],
    counter_contratos: 0,
    counter_contratos_processados: 0,
    counter_contratos_faturados: 0,
    dialog_loading: false
  }),
  created: function() {
    this.listFaturamentos();
    this.countContratos();
    this.countContratosProcessados();
    this.countContratosFaturados();
  },
  methods: {
    countContratos: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/compels/done/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    countContratosProcessados: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/faturamento/process/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos_processados = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    countContratosFaturados: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/faturamento/done/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos_faturados = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    listFaturamentos: function() {
      var me = this;
      me.current = [];
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/internet/faturamento/month", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.current = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar listagem!");
      });
    },
    faturar: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_check = false;
      me.dialog_loading = true;
      api.post("/internet/faturamento", null, {headers: { Authorization: "Bearer " + token }})
      .then(function() {
        me.dialog_loading = false;
        alert("Comando enviado com sucesso!");
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao solicitar faturamento!");
      });
    },
    colorStatus: function(item){
      var color = "success";
      if (item.status==1){
        color = "warning";
      }else if(item.status==2){
        color = "secondary";
      }else if(item.status==3){
        color = "error";
      }else if(item.status==4){
        color = "default";
      }
      return color;
    }
  },
  filters: {
    formatStatus: function(item){
      var text = "Habilitado";
      if (item.status==1){
        text = "Bloqueio administrador";
      }else if(item.status==2){
        text = "Bloqueio cliente";
      }else if(item.status==3){
        text = "Bloqueio pagamento";
      }else if(item.status==4){
        text = "Cancelado";
      }
      return text;
    }
  }
}

</script>
